import styled from 'styled-components';

export const GiffStyled = styled.div`
    .gif{
        position: relative;
        img{
            width: 100%;
        }
    }
`;